<template>
  <div class="flex items-stretch space-x-4 px-4 py-4 desk:px-5">
    <div
      v-if="item.image"
      class="h-16 w-16 flex-none overflow-hidden rounded-lg bg-gray-50 desk:h-20 desk:w-20"
    >
      <img
        :src="item.image"
        :alt="item.name"
        class="h-full w-full object-contain"
      />
    </div>
    <div class="min-w-0 flex-grow overflow-x-scroll scrollbar-hide">
      <p class="text-sm font-bold leading-snug text-gray-800">{{ item.name }}</p>
      <!-- 商品選項 -->
      <p class="text-gray-500 mb-2 text-xs">
        <span class="block" v-for="(option, index) in item.options" :key="index">{{
          option
        }}</span>
      </p>

      <!-- 商品卡密 -->
      <div v-if="variations && success" class="mt-3">
        <div
          v-for="(variation, index) in variations.split(', ')"
          :key="index"
          class="mb-5"
        >
          <CartListItemCardCode
            v-for="(code, subindex) in variation.split(' ')"
            :key="subindex"
            :code="code"
          />
        </div>

        <div class="text-xxs text-red-500 font-bold">＊直接點擊卡密即可複製</div>
      </div>
    </div>

    <div class="flex-none text-sm text-right flex flex-col justify-start items-end space-y-2">
      <!-- 商品價格 -->
      <div class="flex flex-col items-end leading-tight">
        <span v-if="Number(item.origin_price) > Number(item.price)" class="text-xs text-gray-400 line-through">
          {{ currency }}{{ item.origin_price | number_format }}
        </span>
        <p class="font-bold text-gray-800 mt-0.5">{{ currency }}{{ item.price | number_format }}</p>
      </div>
      <!-- 數量調整器 -->
      <QuantityPanel
        :value="item.quantity"
        @input="update"
        :min="0"
        v-if="!view"
      />
      <!-- 顯示數量 -->
      <p v-else class="text-gray-500 font-medium">x{{ item.quantity }}</p>
    </div>

    <!-- <div class="flex-shrink text-sm w-16 text-right">
        <span class="text-xxs">{{ currency }}</span
        >{{ item.price | number_format }}
      </div> -->
  </div>
</template>

<script>
import QuantityPanel from "@/components/order/QuantityPanel";
import { mapActions } from "vuex";
import CartListItemCardCode from "@/components/cart/CartListItemCardCode";

export default {
  components: { QuantityPanel, CartListItemCardCode },
  props: {
    item: Object,
    view: Boolean,
    success: Boolean,
  },
  methods: {
    ...mapActions({
      fetch: "cart/fetch",
    }),
    async update(quantity) {
      try {
        await this.$axios.patch(`/api/cart/${this.item.id}`, { quantity });
        this.fetch();
      } catch (e) {
        this.handleErrorsMessage(e);
      }
    },
  },
  computed: {
    variations() {
      const variations = this.item.variations;

      return typeof variations == "string" ? variations : variations?.join(", ");
    },
  },
};
</script>
